import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_comp_einvoice_intermediary_system_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  creds_json: any;
  descr: fromDatatype.TextDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: any;
  acl_policy: any;
  acl_config: any;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  lhdn_env_type: fromDatatype.VarcharDatatypeInterface;
}


export class bl_fi_mst_comp_einvoice_intermediary_system_RowCLass implements bl_fi_mst_comp_einvoice_intermediary_system_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  creds_json: any;
  descr: fromDatatype.TextDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  property_json: any;
  acl_policy: any;
  acl_config: any;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  lhdn_env_type: fromDatatype.VarcharDatatypeInterface;
}
